import { useEffect, useState } from "react";
import { CheckCheck, ExternalLink } from "lucide-react";

const STEPS = 4;

const reducedMotion = () => typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

export const FlyerChatPreview = () => {
  const [step, setStep] = useState(() => (reducedMotion() ? STEPS : 0));

  useEffect(() => {
    if (reducedMotion()) return undefined;
    if (step >= STEPS) {
      const t = setTimeout(() => setStep(0), 6000);
      return () => clearTimeout(t);
    }
    const delays = [600, 1400, 1100, 900];
    const t = setTimeout(() => setStep((s) => s + 1), delays[step]);
    return () => clearTimeout(t);
  }, [step]);

  const show = (n) => step >= n;

  return (
    <div className="w-full max-w-sm rounded-[2rem] border border-slate-700/80 bg-[#0B141A] shadow-2xl shadow-black/50 overflow-hidden" data-testid="landing-flyer-chat">
      <div className="flex items-center gap-3 bg-[#1F2C34] px-4 py-3">
        <div className="h-9 w-9 rounded-full bg-[#10B981] flex items-center justify-center text-slate-950 font-bold text-sm">SN</div>
        <div className="flex-1 leading-tight">
          <p className="text-sm font-semibold text-white">La tua attività</p>
          <p className="text-[11px] text-[#8696A0]">Account aziendale verificato</p>
        </div>
        <span className="h-2 w-2 rounded-full bg-[#10B981] animate-pulse" />
      </div>

      <div className="relative min-h-[380px] px-3 py-4 space-y-2 wa-chat-bg">
        <p className="mx-auto w-fit rounded-md bg-[#182229] px-2 py-0.5 text-[10px] text-[#8696A0]">Oggi</p>

        {show(1) && (
          <div className="ml-auto w-[88%] rounded-xl rounded-tr-sm bg-[#005C4B] p-1.5 shadow flyer-pop" data-testid="landing-flyer-bubble">
            <img src="/landing/volantino.jpg" alt="Volantino Offerte del weekend" className="h-44 w-full rounded-lg object-cover object-top" data-testid="landing-flyer-image" />
            {show(2) && (
              <div className="px-1.5 pt-2 pb-1 flyer-pop">
                <p className="text-[13px] text-[#E9EDEF] leading-snug">Ciao <strong>Maria</strong>! È arrivato il nuovo volantino: sconti fino al 30% su frutta, carne e prodotti freschi. Ti aspettiamo! 🛒</p>
                <p className="mt-1 flex items-center justify-end gap-1 text-[10px] text-[#8696A0]">
                  09:30 <CheckCheck className={`h-3.5 w-3.5 transition-colors duration-700 ${show(4) ? "text-[#53BDEB]" : ""}`} data-testid="landing-flyer-ticks" />
                </p>
              </div>
            )}
            {show(3) && (
              <div className="mt-1 border-t border-white/10 pt-2 pb-1 flex items-center justify-center gap-1.5 text-[#53BDEB] text-sm font-medium flyer-pop" data-testid="landing-flyer-button">
                <ExternalLink className="h-4 w-4" /> Scopri l'offerta
              </div>
            )}
          </div>
        )}

        {show(4) && (
          <div className="w-[70%] rounded-xl rounded-tl-sm bg-[#202C33] px-3 py-2 shadow flyer-pop" data-testid="landing-flyer-reply">
            <p className="text-[13px] text-[#E9EDEF]">Grazie! Passo sabato mattina 👍</p>
            <p className="mt-0.5 text-right text-[10px] text-[#8696A0]">09:32</p>
          </div>
        )}
      </div>

      <div className="flex items-center justify-between bg-[#1F2C34] px-4 py-2.5 text-[11px] text-[#8696A0]">
        <span>Inviato · Recapitato · <span className="text-[#53BDEB]">Letto</span></span>
        <span>Tracciato nel CRM</span>
      </div>
    </div>
  );
};
